var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#26B99A"
    },
    points: "42,5 16,5 1,5 1,18 57,18 57,5 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#38454F"
    },
    cx: 20,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#38454F"
    },
    cx: 26,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#38454F"
    },
    cx: 32,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#38454F"
    },
    cx: 38,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M38,0c-1.13,0-2.162,0.391-3,1.025c0.534,0.405,0.979,0.912,1.315,1.495C36.796,2.192,37.376,2,38,2 c1.654,0,3,1.346,3,3s-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5S40.757,0,38,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#839594"
    },
    d: "M33.685,2.52C33.261,3.254,33,4.093,33,5h2C35,3.97,34.478,3.061,33.685,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#839594"
    },
    d: "M27.685,2.52C27.261,3.254,27,4.093,27,5h2C29,3.97,28.478,3.061,27.685,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M36.315,2.52C35.979,1.937,35.534,1.43,35,1.025C34.162,0.391,33.13,0,32,0s-2.162,0.391-3,1.025 c0.534,0.405,0.979,0.912,1.315,1.495C30.796,2.192,31.376,2,32,2s1.204,0.192,1.685,0.52C34.478,3.061,35,3.97,35,5 c0,1.654-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5C37,4.093,36.739,3.254,36.315,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#839594"
    },
    d: "M21.685,2.52C21.261,3.254,21,4.093,21,5h2C23,3.97,22.478,3.061,21.685,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M30.315,2.52C29.979,1.937,29.534,1.43,29,1.025C28.162,0.391,27.13,0,26,0s-2.162,0.391-3,1.025 c0.534,0.405,0.979,0.912,1.315,1.495C24.796,2.192,25.376,2,26,2s1.204,0.192,1.685,0.52C28.478,3.061,29,3.97,29,5 c0,1.654-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5C31,4.093,30.739,3.254,30.315,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M24.315,2.52C23.979,1.937,23.534,1.43,23,1.025C22.162,0.391,21.13,0,20,0c-2.757,0-5,2.243-5,5h2 c0-1.654,1.346-3,3-3c0.624,0,1.204,0.192,1.685,0.52C22.478,3.061,23,3.97,23,5c0,1.654-1.346,3-3,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1c2.757,0,5-2.243,5-5C25,4.093,24.739,3.254,24.315,2.52z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18,
    style: {
      fill: "#EDEADA"
    },
    width: 56,
    height: 40
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CEC9AE"
    },
    cx: 13,
    cy: 29,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CEC9AE"
    },
    cx: 29,
    cy: 29,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CEC9AE"
    },
    cx: 45,
    cy: 29,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CEC9AE"
    },
    cx: 13,
    cy: 45,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CEC9AE"
    },
    cx: 29,
    cy: 45,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#26B99A"
    },
    cx: 45,
    cy: 45,
    r: 5
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.bf44edae374805c3b58b107d11a100bd.svg";
export { ForwardRef as ReactComponent };